export const BUSINESS_REQUIREMENT_SITUATION = {
  PRE_REGISTRATION_PENDING: 'pre_registration_pending',
  AWAITING_FIRST_SALE: 'awaiting_first_sale',
  VALIDATION_NOT_STARTED: 'validation_not_started',
  VALIDATION_IN_REVIEW: 'validation_in_review',
  VALIDATION_REJECTED: 'validation_rejected',
};

export const BUSINESS_REQUIREMENT_STEP_STATE = {
  DONE: 'done',
  CURRENT: 'current',
  PENDING: 'pending',
};

export const BUSINESS_REQUIREMENT_ACTION = {
  PRE_REGISTRATION: 'pre_registration',
  PRODUCTS: 'products',
  VALIDATION: 'validation',
  RETRY_VALIDATION: 'retry_validation',
};

// Mesmas cores ja decididas para o selo do negocio em BUSINESS_UI_STATUS_COLOR:
// o info do tema e ciano e destoa, entao o azul vem do secondary.
const BADGE = {
  DONE: { label: 'Concluído', color: 'success' },
  IN_REVIEW: { label: 'Em análise', color: 'secondary' },
  REJECTED: { label: 'Reprovado', color: 'warning' },
};

const STEPS = [
  { number: 1, title: 'Pré-cadastro', description: 'Confirmação dos seus dados pessoais' },
  { number: 2, title: 'Venda', description: 'Faça sua primeira venda na plataforma' },
  { number: 3, title: 'Validação cadastral', description: 'Confirmação da sua identidade' },
];

const { DONE, CURRENT, PENDING } = BUSINESS_REQUIREMENT_STEP_STATE;

const SITUATIONS = {
  [BUSINESS_REQUIREMENT_SITUATION.PRE_REGISTRATION_PENDING]: [
    {
      state: CURRENT,
      action: { id: BUSINESS_REQUIREMENT_ACTION.PRE_REGISTRATION, label: 'Fazer pré-cadastro' },
    },
    { state: PENDING },
    { state: PENDING },
  ],
  [BUSINESS_REQUIREMENT_SITUATION.AWAITING_FIRST_SALE]: [
    { state: DONE, badge: BADGE.DONE },
    {
      state: CURRENT,
      action: {
        id: BUSINESS_REQUIREMENT_ACTION.PRODUCTS,
        label: 'Ir para Produtos',
        secondary: true,
      },
    },
    { state: PENDING },
  ],
  [BUSINESS_REQUIREMENT_SITUATION.VALIDATION_NOT_STARTED]: [
    { state: DONE, badge: BADGE.DONE },
    { state: DONE, badge: BADGE.DONE },
    {
      state: CURRENT,
      action: { id: BUSINESS_REQUIREMENT_ACTION.VALIDATION, label: 'Fazer validação cadastral' },
    },
  ],
  [BUSINESS_REQUIREMENT_SITUATION.VALIDATION_IN_REVIEW]: [
    { state: DONE, badge: BADGE.DONE },
    { state: DONE, badge: BADGE.DONE },
    {
      state: CURRENT,
      badge: BADGE.IN_REVIEW,
      description:
        'Sua identidade está em análise. Avisaremos assim que a validação for concluída.',
    },
  ],
  [BUSINESS_REQUIREMENT_SITUATION.VALIDATION_REJECTED]: [
    { state: DONE, badge: BADGE.DONE },
    { state: DONE, badge: BADGE.DONE },
    {
      state: CURRENT,
      badge: BADGE.REJECTED,
      description: 'Sua identidade não pode ser validada. Tente novamente.',
      action: { id: BUSINESS_REQUIREMENT_ACTION.RETRY_VALIDATION, label: 'Tentar novamente' },
    },
  ],
};

export const getBusinessRequirementSteps = (situation) => {
  const overrides =
    SITUATIONS[situation] ?? SITUATIONS[BUSINESS_REQUIREMENT_SITUATION.PRE_REGISTRATION_PENDING];

  return STEPS.map((step, index) => ({ ...step, ...overrides[index] }));
};
